/*
 * Public API Surface of widget
 */

export * from './lib/widget'

export * from './lib/theme-switcher/theme-switcher.widget'
export * from './lib/theme-switcher/toggle-theme.service'
export * from './lib/language-switcher/language-switcher.widget'
export * from './lib/fullscreen-switcher/fullscreen-switcher.widget'
export * from './lib/user/menu/user-menu.widget'
export * from './lib/user/app-shortcut/user-app-shortcut.widget'

